export class ViewEnterpriseDashboardBudgetMonthDetail {
	public label: string;

	public prevBudget: number;
	public actual: number;
	public varianceAmount: number;
	public variancePercent: number;
	public nextBudget: number;
	public nextBudgetPercent: number;

	constructor(viewEnterpriseDashboardBudgetMonthDetail: ViewEnterpriseDashboardBudgetMonthDetail) {
		Object.assign(this, viewEnterpriseDashboardBudgetMonthDetail);
	}
}
